import { badgeHtml } from "@productlane/lib/src/tiptap/extensions/mintlify/badge-html"
import {
	MDX_ATTRIBUTES_SOURCE,
	readMdxAttributes,
} from "@productlane/lib/src/tiptap/extensions/mintlify/icon-html"

const BADGE = new RegExp(
	`<Badge${MDX_ATTRIBUTES_SOURCE}>([\\s\\S]*?)</Badge>`,
	"g",
)

/** marked leaves an inline `<Badge>` as raw HTML; this turns it into ours. */
export function renderBadgeInline(html: string): string {
	return html.replace(BADGE, (_whole, attributes: string, inner: string) =>
		badgeHtml(readMdxAttributes(attributes ?? ""), inner),
	)
}
